// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1y3hU","log":"ModalInventoryLogs_log__2XHci","date":"ModalInventoryLogs_date__1L0FY","userName":"ModalInventoryLogs_userName__7qIlh"};